import { render, staticRenderFns } from "./global-change-tags.vue?vue&type=template&id=78f978af&scoped=true&"
import script from "./global-change-tags.vue?vue&type=script&lang=js&"
export * from "./global-change-tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f978af",
  null
  
)

export default component.exports